"use client";

import Image from "next/image";
import styles from "../page.module.css";
import { MdAddAPhoto } from "react-icons/md";
import { useEffect, useState } from "react";
import PhotoUploader from "./photo-uploader";
import { useUserDataContext } from "../user-data-context";
import { useScrollLock } from "@/hooks/use-scroll-lock";

export default function ProfileImage() {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const { state } = useUserDataContext();

  useScrollLock(isUploadOpen);

  return (
    <>
      <div className={styles.imageWrapper}>
        <Image
          className={styles.profileImage}
          src={state.photo_url}
          width={512}
          height={512}
          alt="User uploaded profile photo."
        />
        <div
          onClick={() => {
            setIsUploadOpen(true);
          }}
          className={styles.imageOverlay}
          role="button"
          tabIndex={0}
          aria-label={"Change profile photo."}
        >
          <MdAddAPhoto />
        </div>
      </div>
      {isUploadOpen && (
        <PhotoUploader onCloseAction={() => setIsUploadOpen(false)} />
      )}
    </>
  );
}
